<template>
    <v-ons-page>
        <v-ons-tabbar v-show="isAuthed"
            swipeable
            :position="this.isAndroid() ? 'bottom' : 'top'"
            :modifier="this.md() ? 'autogrow white-content' : ''"
            :on-swipe="this.md() ? onSwipe : null"
            :tabbar-style="swipeTheme"
            :tabs="tabs"
            :index.sync="index"
            @prechange="changeTab($event)"
        ></v-ons-tabbar>
      <div class="no-info" v-show="!isAuthed"><h4>
        Please refresh the app if you're seeing this page. Contact support if the message persists
      </h4></div>
    </v-ons-page>
</template>

<script>
import Home from './Home.vue';
import TopUp from './TopUp.vue';
import Account from './Account.vue';
import Data from './data/Data.vue';
import bus from '@/bus';

const darkgrey = [50, 50, 50];

export default {
    data() {
        return {
            shutUp: !this.md(),
            showingTip: false,
            colors: darkgrey,
            animationOptions: {},
            topPosition: 0,
            tabs: [
                {
                    label: 'Voice',
                    icon: 'fa-phone',
                    page: Home,
                    theme: darkgrey
                },
                {
                    label: 'Preference',
                    icon: 'fa-user-circle',
                    page: Account,
                    theme: darkgrey,
                },
            ],
            isAdmin: false,
            isDeveloper: false,
            isAuthed: true
        };
    },
    methods: {
        onSwipe(index, animationOptions) {
            // Apply the same transition as ons-tabbar
            this.animationOptions = animationOptions;
        },
        showTip(e, message) {
            if (!this.shutUp && !(e && e.swipe) && !this.showingTip) {
                this.showingTip = true;
                this.$ons.notification
                    .toast({
                        message,
                        buttonLabel: 'Shut up!',
                        timeout: 2000,
                    })
                    .then(i => {
                        this.shutUp = i === 0;
                        this.showingTip = false;
                    });
            }
        },
        md() {},
        isAndroid() {
            return this.$ons.platform.isAndroid();
        },
        changeTab(e) {
            // e.cancel();
        },
        async getToken(domain, username, password) {
            const url = `/token?domain=${domain}&username=${username}&password=${password}`;
            return await this.$http.get(url);
        },
        getCallForwardingSettings() {
            return this.$http.get('/forwardcall', { headers: headers });
        },
        getlocatStorageToken() {
            const _token = localStorage.getItem('app:ACCESS_TOKEN');
            if (!_token) {
                return;
            }
            return _token;
        },
        listenForAdminStatus() {
          bus.$on("::ISADMIN", (status) => {
            this.isAdmin = status;
            if (this.isAdmin) {
              this.tabs.splice(1, 0, {
                    label: 'Purchase',
                    icon: 'fa-piggy-bank',
                    page: TopUp,
                    theme: darkgrey,
                  });
            }
          });
          bus.$on("::ISDEVELOPER", (status) => {
            this.isDeveloper = status;
            if (this.isDeveloper) {
              this.tabs.splice(2, 0, {
                label: 'Data',
                icon: 'fa-cloud',
                page: Data,
                theme: darkgrey
              });
            }
          })
        }
    },
    mounted() {
        const domain = this.$route.query.domain;
        const username = this.$route.query.username;
        const password = this.$route.query.password;
        if (username && password && domain) {
            this.getToken(domain, username, password)
                .then(response => {
                    if (response.status === 200) {
                        const _username = btoa(username);
                        const _password = btoa(password);
                        const _domain = btoa(domain);
                        localStorage.setItem('app:ACCESS_TOKEN', response.data);
                        localStorage.setItem('app:USERNAME', _username);
                        localStorage.setItem('app:PASSWORD', _password);
                        localStorage.setItem('app:DOMAIN', _domain);
                        bus.$emit(':tokenReceived');
                        this.isAuthed = true;
                    }
                })
                .catch(err => {
                  localStorage.removeItem('app:ACCESS_TOKEN');
                  localStorage.removeItem('app:USERNAME');
                  localStorage.removeItem('app:PASSWORD');
                  localStorage.removeItem('app:DOMAIN');
                  this.isAuthed = false;
                  this.$ons.notification.alert('Failed to get user access token', { title: 'Authorization' });
                });
        } else {
            const storedToken = localStorage.getItem('app:ACCESS_TOKEN');
            if (!storedToken) {
               this.isAuthed = false;
              // this.$ons.notification.alert('Failed to get user access token', { title: 'Authorization' })
            }
        }
        this.listenForAdminStatus();
        /** Hey, I was just following orders */
        setInterval( () => {
          bus.$emit("NEWBALANCE");
        }, 30 * 1000);
        setInterval(() => {
          bus.$emit("NEWCALLREPORTS");
        }, 2 * 60 * 1000)
    },
    computed: {
        index: {
            get() {
                return 0;
                // return this.$store.state.tabbar.index;
            },
            set(newValue) {
                this.$store.commit('tabbar/set', newValue);
            },
        },
        swipeTheme() {
            return (
                this.md && {
                    backgroundColor: `rgb(${this.colors.join(',')})`,
                    transition: `all ${this.animationOptions.duration || 0}s ${this.animationOptions.timing || ''}`,
                }
            );
        },
        swipePosition() {
            return (
                this.md && {
                    top: this.topPosition + 'px',
                    transition: `all ${this.animationOptions.duration || 0}s ${this.animationOptions.timing || ''}`,
                }
            );
        },
    },
};
</script>

<style lang="scss">
.tabbar__item.active {
    .tabbar__label,
    .fa {
        color: #00c694 !important;
    }
}
.tabbar__label {
    font-family: 'Poppins',sans-serif !important;
}
.toolbar-header {
    height: 80px;
    margin-bottom: 16px;

    &-logo {
        padding-top: 10px;
        padding-left: 10px;

        img {
            width: 60px;
        }
    }
    &-text {
        padding-top: 20px;
    }
}
.no-info {
  padding: 16px;
  margin-top: 40%;
}
/* Custom 'white-content' modifier */

.page--material .toolbar--white-content__center,
.page--material .toolbar-button--white-content,
.page--material :checked + .tabbar--white-content__button {
    color: white;
}

.page--material .tabbar--white-content__button {
    color: rgba(255, 255, 255, 0.7);
}

.page--material .tabbar--white-content__border {
    background-color: white;
}
.tabbar__button.tabbar--material__button {
    color: #999;
}
</style>
